import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: 'Dejas de adivinar',
    desc: 'tienes un sistema con pasos claros y secuenciados'
  }, {
    title: 'Tu contenido trabaja para ti',
    desc: 'incluso cuando tú no estás frente a la pantalla'
  }, {
    title: 'Construyes autoridad real',
    desc: 'no solo seguidores, sino audiencias que compran'
  }, {
    title: 'Optimizas con datos',
    desc: 'no con intuición ni esperanza'
  }, {
    title: 'Evitas los errores costosos',
    desc: 'los más comunes ya están documentados con sus soluciones'
  }, {
    title: 'Escalas a tu ritmo',
    desc: 'sin necesitar un equipo ni un presupuesto enorme'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-17">
            Beneficios Reales{' '}
            <span className="text-gold-400" data-id="element-18">— Traducidos a tu vida</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-19">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex items-start space-x-4 bg-navy-950/30 p-5 rounded-xl border border-white/5" data-id="element-20">
              <div className="flex-shrink-0 mt-1" data-id="element-21">
                <div className="w-6 h-6 rounded-full bg-gold-500/20 flex items-center justify-center border border-gold-500/30" data-id="element-22">
                  <Check className="w-3.5 h-3.5 text-gold-400" data-id="element-23" />
                </div>
              </div>
              <p className="text-lg" data-id="element-24">
                <strong className="text-white font-medium" data-id="element-25">
                  {benefit.title}
                </strong>{' '}
                <span className="text-slate-400" data-id="element-26">— {benefit.desc}</span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}